class CSVExporter {
	createFileContentsFromArrayOfRowObjects(arrayOfRowObjects) {
		let columns = [];
		let prepArray = [];
		for (let rowNumber in arrayOfRowObjects) {
			let row = arrayOfRowObjects[rowNumber];
			let rowArray = {};
			prepArray.push(rowArray);
			for (let propName in row) {
				let colNumber;
				let foundIndex = columns.indexOf(propName);
				if (foundIndex >= 0) {
					colNumber = foundIndex;
				} else {
					columns.push(propName);
					colNumber = columns.length - 1;
				}
				rowArray[colNumber] = row[propName];
			}
		}
		let numCols = columns.length;
		let headerRow = [];
		for (let i = 0; i < numCols; i++) {
			let headerTitle = columns[i] + '';
			let innerString = '"' + headerTitle.replace(/"/g, '""') + '"';
			headerRow.push(innerString);
		}
		let dataString = headerRow.join(',');
		let csvContent = '';
		csvContent += dataString + '\n';
		prepArray.forEach(function (infoArray, index) {
			let finalRowArr = [];
			for (let i = 0; i < numCols; i++) {
				if (i in infoArray) {
					let val = infoArray[i] + '';
					let innerString = '"' + val.replace(/"/g, '""') + '"';
					finalRowArr.push(innerString);
				} else {
					finalRowArr.push('');
				}
			}
			dataString = finalRowArr.join(',');
			csvContent += index < arrayOfRowObjects.length ? dataString + '\n' : dataString;
		});
		return csvContent;
	}
	exportFile(fileContents, filename = 'export.csv') {
		const blob = new Blob([fileContents], { type: 'text/csv' });
		let encodedURI = window.URL.createObjectURL(blob);
		let link = document.createElement('a');
		link.setAttribute('href', encodedURI);
		link.setAttribute('download', filename);
		document.body.appendChild(link); // Required for FF
		link.click(); // This will download the data file
	}
	exportArrayOfRowObjects(arrayOfRowObjects, filename) {
		this.exportFile(this.createFileContentsFromArrayOfRowObjects(arrayOfRowObjects), filename);
	}
}
export default new CSVExporter();
